(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cc-artwork-upload"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-artwork-upload')) {
    const ALLOWED_EXTENSIONS = /\.(png|jpe?g|webp|svg|pdf|ai|eps)$/i;
    const ALLOWED_LABELS = 'PNG, JPG, WEBP, SVG, PDF, AI, or EPS';

    class CcArtworkUpload extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.cc-upload__input');
        this.urlInput = this.querySelector('.cc-upload__url-input');
        this.extraInputsContainer = this.querySelector('.cc-upload__extra-inputs');
        this.buttonLabel = this.querySelector('.cc-upload__button');
        this.buttonText = this.querySelector('.cc-upload__button-text');
        this.progressBox = this.querySelector('.cc-upload__progress');
        this.progressText = this.querySelector('.cc-upload__progress-text');
        this.progressBar = this.querySelector('.cc-upload__progress-bar');
        this.cancelBtn = this.querySelector('.cc-upload__cancel');
        this.box = this.querySelector('.cc-upload__file');
        this.multiList = this.querySelector('.cc-upload__multi-list');
        this.thumb = this.querySelector('.cc-upload__thumb');
        this.badge = this.querySelector('.cc-upload__badge');
        this.nameEl = this.querySelector('.cc-upload__name');
        this.linkEl = this.querySelector('.cc-upload__link');
        this.removeBtn = this.querySelector('.cc-upload__remove');
        this.errorBox = this.querySelector('.cc-upload__error-box');
        this.err = this.querySelector('.cc-upload__error');
        this.retryBtn = this.querySelector('.cc-upload__retry-btn');
        this.chooseBtn = this.querySelector('.cc-upload__choose-btn');
        this.skipBtn = this.querySelector('.cc-upload__skip-btn');

        this.maxMb = parseFloat(this.dataset.maxMb) || 20;
        this.maxBytes = this.maxMb * 1024 * 1024;
        this.maxFiles = parseInt(this.dataset.maxFiles, 10) || 5;
        this.state = 'idle'; // 'idle' | 'uploading' | 'uploaded' | 'error'
        this.pendingFiles = [];
        this.uploadedFiles = []; // Array of { name, size, ext, cdnUrl, dataUrl, isImage }
        this.uploadedUrl = '';
        this.activeXhr = null;
        this.uploadToken = 0;

        if (!this.input) return;

        // Clean up any leftover `_cc_temp_upload` items from interrupted sessions on load
        this.cleanupTempCartItem(null, null);

        this.input.addEventListener('change', () => {
          const files = this.input.files ? Array.from(this.input.files) : [];
          if (!files.length) return;
          this.handleSelectedFiles(files);
        });

        if (this.buttonLabel) {
          this.buttonLabel.addEventListener('dragover', (e) => {
            e.preventDefault();
            this.buttonLabel.classList.add('is-dragover');
          });
          this.buttonLabel.addEventListener('dragleave', () => {
            this.buttonLabel.classList.remove('is-dragover');
          });
          this.buttonLabel.addEventListener('drop', (e) => {
            e.preventDefault();
            this.buttonLabel.classList.remove('is-dragover');
            const files = e.dataTransfer && e.dataTransfer.files ? Array.from(e.dataTransfer.files) : [];
            if (files.length) this.handleSelectedFiles(files);
          });
        }

        if (this.removeBtn) {
          this.removeBtn.addEventListener('click', () => {
            if (this.uploadedFiles.length <= 1) {
              this.resetToIdle();
            } else {
              this.removeUploadedFileAt(0);
            }
          });
        }

        if (this.multiList) {
          this.multiList.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-remove-index]');
            if (!btn) return;
            const idx = parseInt(btn.getAttribute('data-remove-index'), 10);
            if (!isNaN(idx)) {
              this.removeUploadedFileAt(idx);
            }
          });
        }

        if (this.cancelBtn) {
          this.cancelBtn.addEventListener('click', () => {
            if (this.activeXhr) {
              try {
                this.activeXhr.abort();
              } catch (e) {}
              this.activeXhr = null;
            }
            if (this.uploadedFiles.length > 0) {
              this.finishUploadedState();
            } else {
              this.resetToIdle();
            }
          });
        }

        if (this.retryBtn) {
          this.retryBtn.addEventListener('click', () => {
            if (this.pendingFiles && this.pendingFiles.length > 0) {
              this.handleSelectedFiles(this.pendingFiles);
            } else {
              this.input.click();
            }
          });
        }

        if (this.chooseBtn) {
          this.chooseBtn.addEventListener('click', () => {
            this.input.value = '';
            this.input.click();
          });
        }

        if (this.skipBtn) {
          this.skipBtn.addEventListener('click', () => {
            if (this.uploadedFiles.length > 0) {
              this.pendingFiles = [];
              this.finishUploadedState();
            } else {
              this.resetToIdle();
            }
          });
        }

        this.setupCheckoutGuards();
      }

      // Backward-compatible single-file helper
      handleSelectedFile(file) {
        if (!file) return;
        this.handleSelectedFiles([file]);
      }

      getProductForm() {
        const formId = this.dataset.formId;
        if (formId) {
          const byId = document.getElementById(formId);
          if (byId) return byId;
        }
        return (
          this.closest('.product-details, .product-information, main')?.querySelector(
            'product-form-component form[action*="/cart/add"]'
          ) || null
        );
      }

      getCurrentVariantId() {
        const form = this.getProductForm();
        const variantInput = form && form.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) return variantInput.value;
        return this.dataset.variantId || '';
      }

      formatSize(bytes) {
        if (bytes < 1024 * 1024) {
          return Math.max(1, Math.round(bytes / 1024)) + ' KB';
        }
        return (bytes / 1024 / 1024).toFixed(1) + ' MB';
      }

      getExtension(filename) {
        const parts = String(filename || '').split('.');
        return parts.length > 1 ? parts.pop().toUpperCase() : 'FILE';
      }

      isValidCdnUrl(url) {
        if (!url || typeof url !== 'string') return false;
        const trimmed = url.trim();
        if (!trimmed || /fakepath/i.test(trimmed)) return false;
        return /^https?:\/\/.+\/(uploads|files)\//i.test(trimmed);
      }

      normalizeCdnUrl(rawUrl) {
        if (!rawUrl || typeof rawUrl !== 'string') return '';
        const trimmed = rawUrl.trim();
        if (trimmed.startsWith('//')) return 'https:' + trimmed;
        if (trimmed.startsWith('/')) return window.location.origin + trimmed;
        return trimmed;
      }

      syncHiddenUrlInputs() {
        const validFiles = this.uploadedFiles.filter((f) => f && this.isValidCdnUrl(f.cdnUrl));
        const firstUrl = validFiles.length > 0 ? validFiles[0].cdnUrl : '';

        this.uploadedUrl = firstUrl;
        if (this.urlInput) {
          if (firstUrl) {
            this.urlInput.disabled = false;
            this.urlInput.value = firstUrl;
            this.urlInput.setAttribute('value', firstUrl);
          } else {
            this.urlInput.value = '';
            this.urlInput.setAttribute('value', '');
            this.urlInput.disabled = true;
          }
        }

        if (this.extraInputsContainer) {
          this.extraInputsContainer.innerHTML = '';
          const formId = this.dataset.formId || '';
          for (let i = 1; i < validFiles.length; i++) {
            const extraInput = document.createElement('input');
            extraInput.type = 'hidden';
            extraInput.className = 'cc-upload__extra-url-input';
            extraInput.name = 'properties[Artwork ' + (i + 1) + ']';
            if (formId) extraInput.setAttribute('form', formId);
            extraInput.value = validFiles[i].cdnUrl;
            extraInput.setAttribute('value', validFiles[i].cdnUrl);
            this.extraInputsContainer.appendChild(extraInput);
          }
        }
      }

      setUrlInputValue(cdnUrl) {
        if (!cdnUrl) {
          this.uploadedFiles = [];
        }
        this.syncHiddenUrlInputs();
      }

      removeUploadedFileAt(index) {
        if (index < 0 || index >= this.uploadedFiles.length) return;
        this.uploadedFiles.splice(index, 1);
        if (this.uploadedFiles.length === 0) {
          this.resetToIdle();
        } else {
          this.finishUploadedState();
        }
      }

      resetToIdle() {
        this.uploadToken += 1;
        if (this.activeXhr) {
          try {
            this.activeXhr.abort();
          } catch (e) {}
          this.activeXhr = null;
        }
        this.pendingFiles = [];
        this.uploadedFiles = [];
        this.uploadedUrl = '';
        if (this.input) this.input.value = '';
        this.syncHiddenUrlInputs();

        this.state = 'idle';
        this.dataset.uploadState = 'idle';
        this.classList.remove('has-file', 'is-uploading', 'has-error');

        if (this.progressBox) this.progressBox.hidden = true;
        if (this.box) this.box.hidden = true;
        if (this.multiList) {
          this.multiList.innerHTML = '';
          this.multiList.hidden = true;
        }
        if (this.errorBox) this.errorBox.hidden = true;
        if (this.err) this.err.textContent = '';
        if (this.thumb) {
          this.thumb.removeAttribute('src');
          this.thumb.hidden = true;
        }
        if (this.badge) this.badge.hidden = true;
        if (this.buttonText && this.buttonText.dataset.defaultLabel) {
          this.buttonText.textContent = this.buttonText.dataset.defaultLabel;
        }

        this.syncCheckoutButtons();
      }

      showError(message, canRetry) {
        if (this.uploadedFiles.length === 0) {
          this.syncHiddenUrlInputs();
        }
        this.state = 'error';
        this.dataset.uploadState = 'error';
        this.classList.remove('is-uploading');
        this.classList.add('has-error');

        if (this.progressBox) this.progressBox.hidden = true;
        if (this.uploadedFiles.length === 0 && this.box) {
          this.box.hidden = true;
        }
        if (this.err) this.err.textContent = message;
        if (this.retryBtn) this.retryBtn.hidden = !canRetry;
        if (this.errorBox) this.errorBox.hidden = false;

        this.syncCheckoutButtons();
      }

      validateSingleFile(file) {
        if (!file) {
          return { valid: false, message: 'No file selected.' };
        }
        if (!ALLOWED_EXTENSIONS.test(file.name || '')) {
          const ext = this.getExtension(file.name);
          return {
            valid: false,
            message:
              'Unsupported file format (.' +
              ext.toLowerCase() +
              ') for "' +
              file.name +
              '". Only ' +
              ALLOWED_LABELS +
              ' files up to ' +
              this.maxMb +
              ' MB are accepted.'
          };
        }
        if (!file.size || file.size <= 0) {
          return {
            valid: false,
            message:
              'The selected file "' +
              file.name +
              '" is empty (0 KB). Please choose a valid ' +
              ALLOWED_LABELS +
              ' file.'
          };
        }
        if (file.size > this.maxBytes) {
          return {
            valid: false,
            message:
              'File "' +
              file.name +
              '" is ' +
              this.formatSize(file.size) +
              ', which exceeds the ' +
              this.maxMb +
              ' MB limit. Please upload a smaller file (max ' +
              this.maxMb +
              ' MB) or remove it and email your artwork to support@getcharmcraft.com.'
          };
        }
        return { valid: true, message: '' };
      }

      handleSelectedFiles(files) {
        const fileList = Array.from(files || []);
        if (!fileList.length) return;

        this.uploadToken += 1;
        const currentToken = this.uploadToken;
        if (this.activeXhr) {
          try {
            this.activeXhr.abort();
          } catch (e) {}
          this.activeXhr = null;
        }

        // Clear native file input value immediately so `C:\fakepath\...` never lingers in DOM
        // and so selecting the same file again always triggers `change`.
        if (this.input) {
          this.input.value = '';
        }

        // Check max file count (5 files)
        const remainingSlots = this.maxFiles - this.uploadedFiles.length;
        if (remainingSlots <= 0) {
          this.pendingFiles = [];
          this.showError(
            'You have already uploaded the maximum of ' +
              this.maxFiles +
              ' artwork files. Please remove a file if you want to replace it, or email additional files to support@getcharmcraft.com.',
            false
          );
          return;
        }

        if (fileList.length > remainingSlots) {
          this.pendingFiles = [];
          this.showError(
            'You selected ' +
              fileList.length +
              ' files, but up to ' +
              this.maxFiles +
              ' files can be uploaded per item (' +
              remainingSlots +
              ' slot' +
              (remainingSlots === 1 ? '' : 's') +
              ' remaining). Please select up to ' +
              remainingSlots +
              ' file' +
              (remainingSlots === 1 ? '' : 's') +
              ' (' +
              ALLOWED_LABELS +
              ', max ' +
              this.maxMb +
              ' MB each).',
            false
          );
          return;
        }

        // Validate every selected file before starting upload
        for (const file of fileList) {
          const check = this.validateSingleFile(file);
          if (!check.valid) {
            this.pendingFiles = [];
            this.showError(check.message, false);
            return;
          }
        }

        this.pendingFiles = fileList;
        this.uploadFilesBatch(fileList, currentToken);
      }

      readDataUrl(file) {
        return new Promise((resolve) => {
          const isRaster = file.type && file.type.startsWith('image/') && file.type !== 'image/svg+xml';
          const isSvg = file.type === 'image/svg+xml' || /\.svg$/i.test(file.name || '');
          if (!isRaster && !isSvg) {
            resolve({ isImage: false, dataUrl: '' });
            return;
          }
          const reader = new FileReader();
          reader.onload = (e) => {
            resolve({ isImage: true, dataUrl: (e && e.target && e.target.result) || '' });
          };
          reader.onerror = () => resolve({ isImage: false, dataUrl: '' });
          reader.readAsDataURL(file);
        });
      }

      async cleanupTempCartItem(tempKey, tempTag) {
        const headers = {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        };
        try {
          if (tempKey) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers,
              credentials: 'same-origin',
              body: JSON.stringify({ id: tempKey, quantity: 0 })
            });
          }
        } catch (e) {}

        // Fallback safety check: verify no item with `_cc_temp_upload` remains in cart
        try {
          const cartRes = await fetch('/cart.js', {
            method: 'GET',
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });
          if (cartRes.ok) {
            const cart = await cartRes.json();
            const tempItems = (cart.items || []).filter(
              (item) =>
                item &&
                item.properties &&
                (tempTag ? item.properties._cc_temp_upload === tempTag : Boolean(item.properties._cc_temp_upload))
            );
            for (const item of tempItems) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers,
                credentials: 'same-origin',
                body: JSON.stringify({ id: item.key, quantity: 0 })
              });
            }
          }
        } catch (e) {}
      }

      uploadSingleFileViaXhr(file, token, batchIndex, batchTotal) {
        return new Promise((resolve) => {
          const variantId = this.getCurrentVariantId();
          if (!variantId) {
            resolve({
              ok: false,
              error:
                'Unable to upload artwork right now (missing product variant). Please retry or remove the file to email it later.'
            });
            return;
          }

          const prefix = batchTotal > 1 ? '(' + (batchIndex + 1) + '/' + batchTotal + ') ' : '';
          const tempTag = 'cc_temp_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9);
          const formData = new FormData();
          formData.append('id', String(variantId));
          formData.append('quantity', '1');
          formData.append('properties[_cc_temp_upload]', tempTag);
          formData.append('properties[Artwork]', file, file.name);

          const xhr = new XMLHttpRequest();
          this.activeXhr = xhr;
          xhr.open('POST', '/cart/add.js', true);
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.timeout = 90000;

          xhr.upload.onprogress = (e) => {
            if (this.uploadToken !== token) return;
            if (e.lengthComputable && e.total > 0) {
              const filePct = Math.min(90, Math.max(8, Math.round((e.loaded / e.total) * 90)));
              const overallPct = Math.round(((batchIndex * 100 + filePct) / batchTotal));
              if (this.progressBar) this.progressBar.style.width = overallPct + '%';
              if (this.progressText) {
                this.progressText.textContent = 'Uploading ' + prefix + file.name + '… ' + filePct + '%';
              }
            }
          };

          xhr.onload = async () => {
            this.activeXhr = null;
            let data = null;
            try {
              data = JSON.parse(xhr.responseText || '{}');
            } catch (e) {
              data = null;
            }
            const tempKey = data && data.key ? data.key : null;

            if (this.uploadToken === token && this.progressText) {
              this.progressText.textContent = 'Finalizing ' + prefix + file.name + '…';
            }

            // Always remove temporary cart line item before resolving
            await this.cleanupTempCartItem(tempKey, tempTag);

            if (this.uploadToken !== token) {
              resolve({ ok: false, cancelled: true });
              return;
            }

            if (xhr.status < 200 || xhr.status >= 300 || !data) {
              const serverMsg = (data && (data.description || data.message)) || '';
              resolve({
                ok: false,
                error:
                  'Artwork upload failed for "' +
                  file.name +
                  '"' +
                  (serverMsg ? ' (' + serverMsg + ')' : '') +
                  '. Please click "Retry upload" or choose "Remove file & email artwork later" to continue.'
              });
              return;
            }

            const rawCdnUrl = data.properties && data.properties.Artwork;
            const cdnUrl = this.normalizeCdnUrl(rawCdnUrl);

            if (!this.isValidCdnUrl(cdnUrl)) {
              resolve({
                ok: false,
                error:
                  'We could not verify the uploaded link for "' +
                  file.name +
                  '". Please click "Retry upload" or choose "Remove file & email artwork later" so your artwork is never lost.'
              });
              return;
            }

            resolve({ ok: true, cdnUrl });
          };

          xhr.onerror = async () => {
            this.activeXhr = null;
            await this.cleanupTempCartItem(null, tempTag);
            if (this.uploadToken !== token) {
              resolve({ ok: false, cancelled: true });
              return;
            }
            resolve({
              ok: false,
              error:
                'Network error while uploading "' +
                file.name +
                '". Please check your connection and click "Retry upload", or choose "Remove file & email artwork later".'
            });
          };

          xhr.ontimeout = async () => {
            this.activeXhr = null;
            await this.cleanupTempCartItem(null, tempTag);
            if (this.uploadToken !== token) {
              resolve({ ok: false, cancelled: true });
              return;
            }
            resolve({
              ok: false,
              error:
                'Uploading "' +
                file.name +
                '" timed out. Please click "Retry upload" or choose "Remove file & email artwork later".'
            });
          };

          xhr.send(formData);
        });
      }

      async uploadFilesBatch(fileList, token) {
        this.state = 'uploading';
        this.dataset.uploadState = 'uploading';
        this.classList.remove('has-error');
        this.classList.add('is-uploading');

        if (this.errorBox) this.errorBox.hidden = true;
        if (this.progressBox) this.progressBox.hidden = false;
        if (this.progressBar) this.progressBar.style.width = '8%';
        if (this.progressText) {
          const prefix = fileList.length > 1 ? '(1/' + fileList.length + ') ' : '';
          this.progressText.textContent = 'Uploading ' + prefix + fileList[0].name + '… 0%';
        }
        this.syncCheckoutButtons();

        const newlyUploaded = [];
        for (let i = 0; i < fileList.length; i++) {
          if (this.uploadToken !== token) return;
          const file = fileList[i];
          const res = await this.uploadSingleFileViaXhr(file, token, i, fileList.length);
          if (this.uploadToken !== token || res.cancelled) return;
          if (!res.ok) {
            // Keep remaining failed files in pendingFiles so Retry works
            this.pendingFiles = fileList.slice(i);
            this.uploadedFiles = this.uploadedFiles.concat(newlyUploaded);
            this.syncHiddenUrlInputs();
            this.renderUploadedFilesUI();
            this.showError(res.error, true);
            return;
          }
          const preview = await this.readDataUrl(file);
          newlyUploaded.push({
            name: file.name,
            size: file.size,
            ext: this.getExtension(file.name),
            cdnUrl: res.cdnUrl,
            dataUrl: preview.dataUrl,
            isImage: preview.isImage
          });
        }

        if (this.uploadToken !== token) return;
        this.pendingFiles = [];
        this.uploadedFiles = this.uploadedFiles.concat(newlyUploaded);
        this.finishUploadedState();
      }

      renderUploadedFilesUI() {
        const count = this.uploadedFiles.length;
        if (count === 0) {
          if (this.box) this.box.hidden = true;
          if (this.multiList) {
            this.multiList.innerHTML = '';
            this.multiList.hidden = true;
          }
          return;
        }

        // First file is always shown in primary `.cc-upload__file` card for 100% compatibility
        const first = this.uploadedFiles[0];
        if (this.nameEl) {
          this.nameEl.textContent =
            (count > 1 ? '1. ' : '') + first.name + ' (' + this.formatSize(first.size) + ')';
        }
        if (this.linkEl) {
          this.linkEl.href = first.cdnUrl;
        }
        if (this.thumb && this.badge) {
          if (first.isImage && first.dataUrl) {
            this.badge.hidden = true;
            this.thumb.src = first.dataUrl;
            this.thumb.hidden = false;
          } else {
            this.thumb.hidden = true;
            this.badge.textContent = first.ext || 'FILE';
            this.badge.hidden = false;
          }
        }
        if (this.box) this.box.hidden = false;

        // Additional files (2..5) rendered in `.cc-upload__multi-list`
        if (this.multiList) {
          if (count <= 1) {
            this.multiList.innerHTML = '';
            this.multiList.hidden = true;
          } else {
            const itemsHtml = this.uploadedFiles
              .slice(1)
              .map((item, idx) => {
                const realIdx = idx + 1;
                const safeName = String(item.name || '')
                  .replace(/&/g, '&amp;')
                  .replace(/</g, '&lt;')
                  .replace(/>/g, '&gt;')
                  .replace(/"/g, '&quot;');
                const mediaHtml =
                  item.isImage && item.dataUrl
                    ? '<img class="cc-upload__thumb" src="' + item.dataUrl + '" alt="" width="40" height="40">'
                    : '<span class="cc-upload__badge">' + (item.ext || 'FILE') + '</span>';
                return (
                  '<div class="cc-upload__file cc-upload__file--extra">' +
                  mediaHtml +
                  '<div class="cc-upload__file-info">' +
                  '  <div class="cc-upload__file-status">' +
                  '    <svg class="cc-upload__check" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clip-rule="evenodd"/></svg>' +
                  '    <span class="cc-upload__name">' +
                  (realIdx + 1) +
                  '. ' +
                  safeName +
                  ' (' +
                  this.formatSize(item.size) +
                  ')</span>' +
                  '  </div>' +
                  '  <div class="cc-upload__file-meta">' +
                  '    <span class="cc-upload__ready-tag">Uploaded &amp; ready</span>' +
                  '    <a class="cc-upload__link" href="' +
                  item.cdnUrl +
                  '" target="_blank" rel="noopener">View uploaded file &#8599;</a>' +
                  '  </div>' +
                  '</div>' +
                  '<button type="button" class="cc-upload__remove" data-remove-index="' +
                  realIdx +
                  '" aria-label="Remove file">&times;</button>' +
                  '</div>'
                );
              })
              .join('');
            this.multiList.innerHTML = itemsHtml;
            this.multiList.hidden = false;
          }
        }

        if (this.buttonText) {
          if (count < this.maxFiles) {
            this.buttonText.textContent =
              'Add another file (' + count + '/' + this.maxFiles + ' uploaded)';
          } else {
            this.buttonText.textContent = count + '/' + this.maxFiles + ' files uploaded';
          }
        }
      }

      finishUploadedState() {
        this.syncHiddenUrlInputs();
        this.renderUploadedFilesUI();

        this.state = 'uploaded';
        this.dataset.uploadState = 'uploaded';
        this.classList.remove('is-uploading', 'has-error');
        this.classList.add('has-file');

        if (this.progressBox) this.progressBox.hidden = true;
        if (this.errorBox) this.errorBox.hidden = true;

        this.syncCheckoutButtons();
      }

      isCheckoutBlocked() {
        return this.state === 'uploading' || this.state === 'error';
      }

      ensureBlockerOverlay(buttonsContainer) {
        if (!buttonsContainer) return null;
        let overlay = buttonsContainer.querySelector('.cc-checkout-blocker');
        if (!overlay) {
          overlay = document.createElement('div');
          overlay.className = 'cc-checkout-blocker';
          overlay.hidden = true;
          overlay.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.nudgeAttention();
          });
          buttonsContainer.appendChild(overlay);
        }
        return overlay;
      }

      nudgeAttention() {
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.classList.remove('cc-upload--shake');
        void this.offsetWidth;
        this.classList.add('cc-upload--shake');
      }

      syncCheckoutButtons() {
        const form = this.getProductForm();
        const productFormComponent = form ? form.closest('product-form-component') : null;
        const buttonsContainer =
          (productFormComponent && productFormComponent.querySelector('.product-form-buttons')) ||
          (form && form.querySelector('.product-form-buttons'));
        const addToCartBtn = form && form.querySelector('[ref="addToCartButton"], button[type="submit"]');
        const acceleratedBlock =
          (buttonsContainer && buttonsContainer.querySelector('.accelerated-checkout-block')) ||
          (form && form.querySelector('.accelerated-checkout-block'));
        const stickyBar = document.querySelector('sticky-add-to-cart');
        const stickyBtn = stickyBar && stickyBar.querySelector('[ref="addToCartButton"], .sticky-add-to-cart__button');

        const blocked = this.isCheckoutBlocked();
        const blockReason =
          this.state === 'uploading'
            ? 'Please wait a moment while your artwork finishes uploading…'
            : this.state === 'error'
              ? 'Please fix or remove the invalid artwork file above to continue to checkout.'
              : '';

        if (buttonsContainer) {
          buttonsContainer.classList.toggle('cc-buttons-blocked', blocked);
          if (blocked) {
            if (buttonsContainer.getAttribute('data-cc-blocked-reason') !== blockReason) {
              buttonsContainer.setAttribute('data-cc-blocked-reason', blockReason);
            }
          } else if (buttonsContainer.hasAttribute('data-cc-blocked-reason')) {
            buttonsContainer.removeAttribute('data-cc-blocked-reason');
          }
          const overlay = this.ensureBlockerOverlay(buttonsContainer);
          if (overlay) {
            if (overlay.hidden !== !blocked) overlay.hidden = !blocked;
            if (overlay.title !== blockReason) overlay.title = blockReason;
          }
        }

        if (addToCartBtn) {
          if (blocked) {
            if (!addToCartBtn.disabled) addToCartBtn.disabled = true;
            if (addToCartBtn.getAttribute('aria-disabled') !== 'true') {
              addToCartBtn.setAttribute('aria-disabled', 'true');
            }
            if (addToCartBtn.getAttribute('data-cc-upload-locked') !== this.state) {
              addToCartBtn.setAttribute('data-cc-upload-locked', this.state);
            }
          } else if (addToCartBtn.hasAttribute('data-cc-upload-locked')) {
            addToCartBtn.removeAttribute('data-cc-upload-locked');
            const variantUnavailable =
              stickyBar && stickyBar.getAttribute('data-variant-available') === 'false';
            if (!variantUnavailable) {
              addToCartBtn.disabled = false;
              addToCartBtn.removeAttribute('aria-disabled');
            }
          }
        }

        if (acceleratedBlock) {
          if (blocked) {
            if (!acceleratedBlock.hasAttribute('inert')) acceleratedBlock.setAttribute('inert', '');
            const busyVal = this.state === 'uploading' ? 'true' : 'false';
            if (acceleratedBlock.getAttribute('aria-busy') !== busyVal) {
              acceleratedBlock.setAttribute('aria-busy', busyVal);
            }
          } else {
            if (acceleratedBlock.hasAttribute('inert')) acceleratedBlock.removeAttribute('inert');
            if (acceleratedBlock.hasAttribute('aria-busy')) acceleratedBlock.removeAttribute('aria-busy');
          }
        }

        if (stickyBtn) {
          if (blocked) {
            if (!stickyBtn.disabled) stickyBtn.disabled = true;
            if (stickyBtn.getAttribute('aria-disabled') !== 'true') {
              stickyBtn.setAttribute('aria-disabled', 'true');
            }
            if (stickyBtn.getAttribute('data-cc-upload-locked') !== this.state) {
              stickyBtn.setAttribute('data-cc-upload-locked', this.state);
            }
          } else if (stickyBtn.hasAttribute('data-cc-upload-locked')) {
            stickyBtn.removeAttribute('data-cc-upload-locked');
            const variantUnavailable =
              stickyBar && stickyBar.getAttribute('data-variant-available') === 'false';
            if (!variantUnavailable) {
              stickyBtn.disabled = false;
              stickyBtn.removeAttribute('aria-disabled');
            }
          }
        }
      }

      setupCheckoutGuards() {
        if (this._guardsAttached) return;
        this._guardsAttached = true;

        const interceptIfBlocked = (e) => {
          if (!this.isConnected) return;
          if (this.isCheckoutBlocked()) {
            const target = e.target;
            const form = this.getProductForm();
            const inProductButtons =
              target &&
              target.closest &&
              (target.closest('.product-form-buttons') ||
                target.closest('shopify-accelerated-checkout') ||
                target.closest('sticky-add-to-cart') ||
                (form && target === form));
            if (inProductButtons) {
              e.preventDefault();
              e.stopPropagation();
              if (typeof e.stopImmediatePropagation === 'function') {
                e.stopImmediatePropagation();
              }
              this.nudgeAttention();
            }
          }
        };

        document.addEventListener('click', interceptIfBlocked, true);
        document.addEventListener('submit', interceptIfBlocked, true);

        // Re-apply checkout button lock if the customer switches product variants while blocked
        document.addEventListener('product:select', (e) => {
          if (!this.isConnected) return;
          const p = e && e.promise;
          if (p && typeof p.then === 'function') {
            p.then(() => {
              setTimeout(() => {
                if (this.isCheckoutBlocked()) this.syncCheckoutButtons();
              }, 30);
            }).catch(() => {});
          } else if (this.isCheckoutBlocked()) {
            setTimeout(() => this.syncCheckoutButtons(), 50);
          }
        });
      }
    }

    customElements.define('cc-artwork-upload', CcArtworkUpload);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cc-name-tag-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-name-tag-builder')) {
    class CcNameTagBuilder extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'dirt_bike';
        this.hasIcons = this.dataset.hasIcons === 'true';
        this.isUploadMode = this.dataset.isUpload === 'true';
        this.iconCount = parseInt(this.dataset.iconCount, 10) || 10;
        this.iconSpriteUrl = this.dataset.iconSprite || '';
        this.hasCuteStrong = this.dataset.hasCuteStrong === 'true';
        this.defaultPreview = this.dataset.defaultPreview || 'MASON';

        this.summaryInput = this.querySelector('.cc-nt__summary-input');
        this.uploadedUrlInput = this.querySelector('.cc-nt__uploaded-url-input');
        this.nameInput = this.querySelector('.cc-nt__name-input');
        this.charCount = this.querySelector('[data-char-count]');
        this.nameError = this.querySelector('#cc-nt-' + this.getBlockUid() + '-name-error') || this.querySelector('[id$="-name-error"]');
        this.contrastWarning = this.querySelector('[data-contrast-warning]');

        // Upload mode elements
        this.uploadInput = this.querySelector('.cc-nt__upload-input');
        this.uploadDropzone = this.querySelector('[data-upload-dropzone]');
        this.uploadBtnTitle = this.querySelector('[data-upload-btn-title]');
        this.uploadPreviewRow = this.querySelector('[data-upload-preview-row]');
        this.uploadThumb = this.querySelector('[data-upload-thumb]');
        this.uploadZoomBtn = this.querySelector('[data-upload-zoom-btn]');
        this.uploadFilenameEl = this.querySelector('[data-upload-filename]');
        this.uploadDimsEl = this.querySelector('[data-upload-dims]');
        this.uploadRemoveBtn = this.querySelector('[data-upload-remove]');
        this.uploadStatusLabel = this.querySelector('[data-upload-status-label]');
        this.rightsCheckbox = this.querySelector('[data-rights-checkbox]');
        this.uploadError = this.querySelector('[data-upload-error]');

        this.previewTag = this.querySelector('[data-preview-tag]');
        this.previewIcon = this.querySelector('[data-preview-icon]');
        this.previewUploadPlaceholder = this.querySelector('[data-preview-upload-placeholder]');
        this.previewUploadImg = this.querySelector('[data-preview-upload-img]');
        this.previewText = this.querySelector('[data-preview-text]');
        this.previewSummary = this.querySelector('[data-preview-summary]');
        this.previewCanvas = this.querySelector('[data-preview-canvas]');
        this._previewText = this.defaultPreview;
        this._iconCache = {};
        this._fontLoadState = {};
        this._uploadedIconImg = null;
        this._uploadedIconCanvas = null;

        this.iconLabelEl = this.querySelector('[data-selected-icon-label]');
        this.fontLabelEl = this.querySelector('[data-selected-font-label]');
        this.textColorLabelEl = this.querySelector('[data-selected-text-color]');
        this.bgColorLabelEl = this.querySelector('[data-selected-bg-color]');
        this.bgStyleLabelEl = this.querySelector('[data-selected-bg-style]');
        const activeShapeBtn = this.querySelector('.cc-nt__shape-btn.is-selected');
        this.selectedBgStyle = activeShapeBtn ? activeShapeBtn.dataset.bgStyle : 'Contour Cut';

        // Lightbox elements
        this.lightbox = this.querySelector('[data-icon-lightbox]');
        this.lightboxTitle = this.querySelector('[data-lightbox-title]');
        this.lightboxSprite = this.querySelector('[data-lightbox-sprite]');
        this.lightboxImg = this.querySelector('[data-lightbox-img]');
        this.lightboxBtnLabel = this.querySelector('[data-lightbox-btn-label]');
        this.lightboxPrevBtn = this.querySelector('[data-lightbox-prev]');
        this.lightboxNextBtn = this.querySelector('[data-lightbox-next]');

        // Initial state
        const activeIconBtn = this.querySelector('.cc-nt__icon-btn.is-selected');
        this.selectedIcon = this.hasIcons
          ? (activeIconBtn ? activeIconBtn.dataset.iconValue : '#1')
          : 'No Icon (Pixel)';

        this.hasUploadedIcon = false;
        this.uploadedFileName = '';
        this.uploadedDataUrl = '';
        this.uploadedCutoutUrl = '';
        this.uploadedCdnUrl = '';

        const activeToneBtn = this.querySelector('.cc-nt__tone-btn.is-selected');
        this.selectedTone = activeToneBtn ? activeToneBtn.dataset.tone : '';

        const activeFontBtn = this.querySelector('.cc-nt__font-btn.is-selected');
        this.selectedFontLabel = activeFontBtn ? activeFontBtn.dataset.fontLabel : '#6';
        this.selectedFontFamily = activeFontBtn ? activeFontBtn.dataset.fontFamily : "'Russo One', sans-serif";

        const activeTextBtn = this.querySelector('.cc-nt__swatch-btn[data-color-role="text"].is-selected');
        this.selectedTextColor = activeTextBtn ? activeTextBtn.dataset.colorName : 'White';
        this.selectedTextHex = activeTextBtn ? activeTextBtn.dataset.colorHex : '#FFFFFF';

        const activeBgBtn = this.querySelector('.cc-nt__swatch-btn[data-color-role="bg"].is-selected');
        this.selectedBgColor = activeBgBtn ? activeBgBtn.dataset.colorName : 'Red';
        this.selectedBgHex = activeBgBtn ? activeBgBtn.dataset.colorHex : '#E53935';

        this.bindEvents();
        this.setupCheckoutGuard();
        this.updateAll();
      }

      getBlockUid() {
        const inp = this.querySelector('.cc-nt__name-input');
        return inp && inp.id ? inp.id.replace(/^cc-nt-|-name$/g, '') : '';
      }

      bindEvents() {
        // 1. Icon Picker + Lightbox Zoom on click
        this.querySelectorAll('.cc-nt__icon-btn').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            this.selectIconButton(btn);
            // Open zoom lightbox when user clicks/taps an icon button (skip if synthetic programmatic test click with isTrusted===false unless zoom badge clicked)
            if (e.isTrusted) {
              this.openIconLightbox(btn);
            }
          });
        });

        if (this.previewCanvas && (this.hasIcons || this.isUploadMode)) {
          this.previewCanvas.addEventListener('click', () => {
            if (this.hasIcons) {
              const activeBtn = this.querySelector('.cc-nt__icon-btn.is-selected');
              if (activeBtn) this.openIconLightbox(activeBtn);
            } else if (this.isUploadMode) {
              if (this.hasUploadedIcon) this.openUploadedIconLightbox();
              else if (this.uploadInput) this.uploadInput.click();
            }
          });
        }

        // Lightbox controls
        if (this.lightbox) {
          this.lightbox.querySelectorAll('[data-lightbox-close]').forEach((el) => {
            el.addEventListener('click', () => this.closeIconLightbox());
          });
          if (this.lightboxPrevBtn) {
            this.lightboxPrevBtn.addEventListener('click', () => this.stepLightboxIcon(-1));
          }
          if (this.lightboxNextBtn) {
            this.lightboxNextBtn.addEventListener('click', () => this.stepLightboxIcon(1));
          }
          document.addEventListener('keydown', (e) => {
            if (this.lightbox && !this.lightbox.hidden) {
              if (e.key === 'Escape') this.closeIconLightbox();
              if (e.key === 'ArrowLeft' && this.hasIcons) this.stepLightboxIcon(-1);
              if (e.key === 'ArrowRight' && this.hasIcons) this.stepLightboxIcon(1);
            }
          });
        }

        // 1B. Upload Mode Events
        if (this.isUploadMode && this.uploadInput) {
          this.uploadInput.addEventListener('change', () => {
            const file = this.uploadInput.files && this.uploadInput.files[0];
            if (file) this.handleIconFileSelect(file);
          });

          if (this.uploadDropzone) {
            this.uploadDropzone.addEventListener('dragover', (e) => {
              e.preventDefault();
              this.uploadDropzone.classList.add('is-dragover');
            });
            this.uploadDropzone.addEventListener('dragleave', () => {
              this.uploadDropzone.classList.remove('is-dragover');
            });
            this.uploadDropzone.addEventListener('drop', (e) => {
              e.preventDefault();
              this.uploadDropzone.classList.remove('is-dragover');
              const file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
              if (file) this.handleIconFileSelect(file);
            });
          }

          if (this.uploadRemoveBtn) {
            this.uploadRemoveBtn.addEventListener('click', () => this.resetUploadedIcon());
          }

          if (this.uploadZoomBtn) {
            this.uploadZoomBtn.addEventListener('click', () => {
              if (this.hasUploadedIcon) this.openUploadedIconLightbox();
            });
          }

          if (this.rightsCheckbox) {
            this.rightsCheckbox.addEventListener('change', () => {
              if (this.rightsCheckbox.checked && this.uploadError && this.hasUploadedIcon) {
                this.uploadError.hidden = true;
              }
            });
          }
        }

        // 2. Monster Truck Cute / Strong Toggle
        this.querySelectorAll('.cc-nt__tone-btn').forEach((btn) => {
          btn.addEventListener('click', () => {
            this.querySelectorAll('.cc-nt__tone-btn').forEach((b) => {
              b.classList.remove('is-selected');
              b.setAttribute('aria-pressed', 'false');
            });
            btn.classList.add('is-selected');
            btn.setAttribute('aria-pressed', 'true');
            this.selectedTone = btn.dataset.tone;

            const targetGroup = this.selectedTone === 'Cute' ? 'soft' : 'hard';
            this.filterFontTab(targetGroup);

            const defaultFontId = btn.dataset.defaultFontId;
            const targetFontBtn = this.querySelector(`.cc-nt__font-btn[data-font-id="${defaultFontId}"]`);
            if (targetFontBtn) {
              this.selectFontButton(targetFontBtn);
            }
            this.updateAll();
          });
        });

        // 3. Font Filter Tabs (All / Hard / Soft)
        this.querySelectorAll('.cc-nt__font-tab').forEach((tab) => {
          tab.addEventListener('click', () => {
            this.filterFontTab(tab.dataset.fontFilter);
          });
        });

        // 4. Font Buttons (#1–#24)
        this.querySelectorAll('.cc-nt__font-btn').forEach((btn) => {
          btn.addEventListener('click', () => {
            this.selectFontButton(btn);
            if (this.hasCuteStrong) {
              const grp = btn.dataset.fontGroup;
              const newTone = grp === 'soft' ? 'Cute' : 'Strong';
              this.selectedTone = newTone;
              this.querySelectorAll('.cc-nt__tone-btn').forEach((tb) => {
                const match = tb.dataset.tone === newTone;
                tb.classList.toggle('is-selected', match);
                tb.setAttribute('aria-pressed', match ? 'true' : 'false');
              });
            }
            this.updateAll();
          });
        });

        // 5. Name Input
        if (this.nameInput) {
          this.nameInput.addEventListener('input', () => {
            if (this.nameInput.value.length > 12) {
              this.nameInput.value = this.nameInput.value.slice(0, 12);
            }
            if (this.nameInput.value.trim().length > 0 && this.nameError) {
              this.nameError.hidden = true;
              this.nameInput.classList.remove('is-invalid');
            }
            this.updateAll();
          });
        }

        // 5B. Background Style (Contour Cut / Classic Bar)
        this.querySelectorAll('.cc-nt__shape-btn').forEach((btn) => {
          btn.addEventListener('click', () => {
            this.querySelectorAll('.cc-nt__shape-btn').forEach((b) => {
              b.classList.remove('is-selected');
              b.setAttribute('aria-checked', 'false');
            });
            btn.classList.add('is-selected');
            btn.setAttribute('aria-checked', 'true');
            this.selectedBgStyle = btn.dataset.bgStyle || 'Contour Cut';
            this.updateAll();
          });
        });

        // 6. Color Swatches (Text & Background)
        this.querySelectorAll('.cc-nt__swatch-btn').forEach((btn) => {
          btn.addEventListener('click', () => {
            const role = btn.dataset.colorRole;
            this.querySelectorAll(`.cc-nt__swatch-btn[data-color-role="${role}"]`).forEach((b) => {
              b.classList.remove('is-selected');
              b.setAttribute('aria-checked', 'false');
            });
            btn.classList.add('is-selected');
            btn.setAttribute('aria-checked', 'true');
            if (role === 'text') {
              this.selectedTextColor = btn.dataset.colorName;
              this.selectedTextHex = btn.dataset.colorHex;
            } else {
              this.selectedBgColor = btn.dataset.colorName;
              this.selectedBgHex = btn.dataset.colorHex;
            }
            this.updateAll();
          });
        });
      }

      selectIconButton(btn) {
        this.querySelectorAll('.cc-nt__icon-btn').forEach((b) => {
          b.classList.remove('is-selected');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');
        this.selectedIcon = btn.dataset.iconValue;
        this.updateAll();
      }

      openIconLightbox(btn) {
        if (!this.lightbox || !btn) return;
        const iconVal = btn.dataset.iconValue || '#1';
        const posPct = btn.dataset.iconPos || '0';
        if (this.lightboxTitle) this.lightboxTitle.textContent = `Icon ${iconVal}`;
        if (this.lightboxBtnLabel) this.lightboxBtnLabel.textContent = iconVal;
        if (this.lightboxImg) this.lightboxImg.hidden = true;
        if (this.lightboxSprite) {
          this.lightboxSprite.hidden = false;
          this.lightboxSprite.style.backgroundImage = `url('${this.iconSpriteUrl}')`;
          this.lightboxSprite.style.backgroundSize = `${this.iconCount * 100}% 100%`;
          this.lightboxSprite.style.backgroundPosition = `${posPct}% 50%`;
        }
        if (this.lightboxPrevBtn) this.lightboxPrevBtn.hidden = false;
        if (this.lightboxNextBtn) this.lightboxNextBtn.hidden = false;
        this.lightbox.hidden = false;
      }

      openUploadedIconLightbox() {
        if (!this.lightbox || !this.hasUploadedIcon) return;
        if (this.lightboxTitle) this.lightboxTitle.textContent = `Uploaded Icon (${this.uploadedFileName})`;
        if (this.lightboxBtnLabel) this.lightboxBtnLabel.textContent = 'Uploaded Icon';
        if (this.lightboxSprite) this.lightboxSprite.hidden = true;
        if (this.lightboxImg) {
          this.lightboxImg.src = this.uploadedCutoutUrl || this.uploadedDataUrl;
          this.lightboxImg.hidden = false;
        }
        if (this.lightboxPrevBtn) this.lightboxPrevBtn.hidden = true;
        if (this.lightboxNextBtn) this.lightboxNextBtn.hidden = true;
        this.lightbox.hidden = false;
      }

      stepLightboxIcon(delta) {
        const buttons = Array.from(this.querySelectorAll('.cc-nt__icon-btn'));
        if (!buttons.length) return;
        const currentIdx = buttons.findIndex((b) => b.classList.contains('is-selected'));
        const nextIdx = (currentIdx + delta + buttons.length) % buttons.length;
        const nextBtn = buttons[nextIdx];
        if (nextBtn) {
          this.selectIconButton(nextBtn);
          this.openIconLightbox(nextBtn);
        }
      }

      closeIconLightbox() {
        if (this.lightbox) this.lightbox.hidden = true;
      }

      handleIconFileSelect(file) {
        if (!file) return;
        const validExt = /\.(png|jpe?g)$/i.test(file.name || '') || /^image\/(png|jpeg)$/i.test(file.type || '');
        if (!validExt) {
          this.showUploadError('Please upload a PNG or JPG image file.');
          this.uploadInput.value = '';
          return;
        }
        if (file.size > 20 * 1024 * 1024) {
          this.showUploadError('File exceeds 20 MB limit. Please choose a smaller PNG or JPG image.');
          this.uploadInput.value = '';
          return;
        }

        this.uploadInput.value = '';
        const reader = new FileReader();
        reader.onload = (e) => {
          const dataUrl = e && e.target ? e.target.result : '';
          if (!dataUrl) return;
          this.uploadedFileName = file.name;
          this.uploadedDataUrl = dataUrl;
          this.hasUploadedIcon = true;

          const img = new Image();
          img.onload = () => {
            const w = img.naturalWidth || img.width;
            const h = img.naturalHeight || img.height;
            const cutoutUrl = this.prepareCutoutPreview(img);
            this.uploadedCutoutUrl = cutoutUrl || dataUrl;

            if (this.uploadThumb) this.uploadThumb.src = this.uploadedCutoutUrl;
            if (this.uploadFilenameEl) this.uploadFilenameEl.textContent = file.name;
            if (this.uploadDimsEl) {
              this.uploadDimsEl.textContent =
                w >= 1000 && h >= 1000
                  ? `${w}×${h}px ✓ High-res ready`
                  : `${w}×${h}px (1000×1000px+ recommended — our design team will adapt it)`;
            }
            if (this.uploadPreviewRow) this.uploadPreviewRow.hidden = false;
            if (this.uploadBtnTitle) this.uploadBtnTitle.textContent = 'Change Uploaded Icon (PNG / JPG)';
            if (this.uploadStatusLabel) this.uploadStatusLabel.textContent = 'Uploaded ✓';
            if (this.uploadError) this.uploadError.hidden = true;

            if (this.previewUploadPlaceholder) this.previewUploadPlaceholder.hidden = true;
            if (this.previewUploadImg) {
              this.previewUploadImg.src = this.uploadedCutoutUrl;
              this.previewUploadImg.hidden = false;
            }
            const cutImg = new Image();
            cutImg.onload = () => {
              this._uploadedIconImg = cutImg;
              this._uploadedIconCanvas = null;
              this.requestPreviewRender();
            };
            cutImg.src = this.uploadedCutoutUrl;
            this.updateAll();
          };
          img.src = dataUrl;
        };
        reader.readAsDataURL(file);

        // Background upload to Shopify CDN so the order also receives a clickable image URL
        this.uploadIconToShopifyCdn(file);
      }

      prepareCutoutPreview(img) {
        try {
          const size = 160;
          const canvas = document.createElement('canvas');
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          const scale = Math.min((size - 8) / img.width, (size - 8) / img.height);
          const dw = Math.round(img.width * scale);
          const dh = Math.round(img.height * scale);
          const dx = Math.round((size - dw) / 2);
          const dy = Math.round((size - dh) / 2);
          ctx.drawImage(img, dx, dy, dw, dh);

          // If corners of the uploaded image are solid white/near-white, make the outer background transparent for realistic 3D die-cut preview
          const imgData = ctx.getImageData(0, 0, size, size);
          const d = imgData.data;
          const cornerIdx = (dx + dy * size) * 4;
          const cr = d[cornerIdx];
          const cg = d[cornerIdx + 1];
          const cb = d[cornerIdx + 2];
          const ca = d[cornerIdx + 3];
          if (ca > 240 && cr > 235 && cg > 235 && cb > 235) {
            const visited = new Uint8Array(size * size);
            const queue = [0, size - 1, (size - 1) * size, size * size - 1];
            for (const q of queue) visited[q] = 1;
            let head = 0;
            while (head < queue.length) {
              const p = queue[head++];
              const idx = p * 4;
              const r = d[idx], g = d[idx + 1], b = d[idx + 2], a = d[idx + 3];
              if (a === 0 || (r > 232 && g > 232 && b > 232)) {
                d[idx + 3] = 0;
                const x = p % size;
                const y = (p - x) / size;
                const neighbors = [];
                if (x > 0) neighbors.push(p - 1);
                if (x < size - 1) neighbors.push(p + 1);
                if (y > 0) neighbors.push(p - size);
                if (y < size - 1) neighbors.push(p + size);
                for (const np of neighbors) {
                  if (!visited[np]) {
                    visited[np] = 1;
                    queue.push(np);
                  }
                }
              }
            }
            ctx.putImageData(imgData, 0, 0);
          }
          return canvas.toDataURL('image/png');
        } catch (e) {
          return '';
        }
      }

      uploadIconToShopifyCdn(file) {
        const variantId = this.dataset.variantId;
        if (!variantId) return;
        const tempTag = 'nt_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
        const fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        fd.append('properties[_cc_temp_upload]', tempTag);
        fd.append('properties[Custom Icon File]', file, file.name);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: fd
        })
          .then((r) => (r.ok ? r.json() : null))
          .then((data) => {
            if (data && data.properties && data.properties['Custom Icon File']) {
              const cdnUrl = data.properties['Custom Icon File'];
              this.uploadedCdnUrl = cdnUrl;
              if (this.uploadedUrlInput) {
                this.uploadedUrlInput.disabled = false;
                this.uploadedUrlInput.value = cdnUrl;
              }
            }
            if (data && data.key) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: data.key, quantity: 0 })
              }).catch(() => {});
            }
          })
          .catch(() => {});
      }

      resetUploadedIcon() {
        this.hasUploadedIcon = false;
        this.uploadedFileName = '';
        this.uploadedDataUrl = '';
        this.uploadedCutoutUrl = '';
        this.uploadedCdnUrl = '';
        this._uploadedIconImg = null;
        this._uploadedIconCanvas = null;
        if (this.uploadInput) this.uploadInput.value = '';
        if (this.uploadedUrlInput) {
          this.uploadedUrlInput.value = '';
          this.uploadedUrlInput.disabled = true;
        }
        if (this.uploadPreviewRow) this.uploadPreviewRow.hidden = true;
        if (this.uploadBtnTitle) this.uploadBtnTitle.textContent = 'Choose Icon Image (PNG / JPG)';
        if (this.uploadStatusLabel) this.uploadStatusLabel.textContent = 'Required';
        if (this.previewUploadImg) {
          this.previewUploadImg.removeAttribute('src');
          this.previewUploadImg.hidden = true;
        }
        if (this.previewUploadPlaceholder) this.previewUploadPlaceholder.hidden = false;
        this.updateAll();
      }

      showUploadError(msg) {
        if (!this.uploadError) return;
        this.uploadError.textContent = msg;
        this.uploadError.hidden = false;
      }

      filterFontTab(filter) {
        this.querySelectorAll('.cc-nt__font-tab').forEach((t) => {
          const active = t.dataset.fontFilter === filter;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.querySelectorAll('.cc-nt__font-btn').forEach((btn) => {
          if (filter === 'all') {
            btn.hidden = false;
          } else {
            btn.hidden = btn.dataset.fontGroup !== filter;
          }
        });
      }

      selectFontButton(btn) {
        this.querySelectorAll('.cc-nt__font-btn').forEach((b) => {
          b.classList.remove('is-selected');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');
        this.selectedFontLabel = btn.dataset.fontLabel;
        this.selectedFontFamily = btn.dataset.fontFamily;
      }

      shadeColor(hex, factor = 0.65) {
        const clean = (hex || '#E53935').replace('#', '');
        const num = parseInt(clean, 16);
        if (Number.isNaN(num)) return '#1e293b';
        const r = Math.max(0, Math.min(255, Math.round(((num >> 16) & 255) * factor)));
        const g = Math.max(0, Math.min(255, Math.round(((num >> 8) & 255) * factor)));
        const b = Math.max(0, Math.min(255, Math.round((num & 255) * factor)));
        return `rgb(${r}, ${g}, ${b})`;
      }

      updateAll() {
        const rawName = this.nameInput ? this.nameInput.value.trim() : '';
        const displayText = rawName || this.defaultPreview;

        // Update character counter
        if (this.charCount && this.nameInput) {
          const len = this.nameInput.value.length;
          this.charCount.textContent = `${len} / 12 characters`;
        }

        // Update font sample previews
        this.querySelectorAll('[data-font-sample]').forEach((el) => {
          el.textContent = displayText;
        });

        // Update selected labels (Number only #1–#24 per Section B)
        if (this.iconLabelEl) this.iconLabelEl.textContent = this.selectedIcon;
        if (this.fontLabelEl) this.fontLabelEl.textContent = this.selectedFontLabel;
        if (this.textColorLabelEl) this.textColorLabelEl.textContent = this.selectedTextColor;
        if (this.bgColorLabelEl) this.bgColorLabelEl.textContent = this.selectedBgColor;
        if (this.bgStyleLabelEl) this.bgStyleLabelEl.textContent = this.selectedBgStyle;

        // Contrast helper
        if (this.contrastWarning) {
          this.contrastWarning.hidden = this.selectedTextColor !== this.selectedBgColor;
        }

        // Update Live 3D PVC Preview (die-cut canvas renderer)
        if (this.previewText) this.previewText.textContent = displayText;
        if (this.previewCanvas) {
          this.previewCanvas.setAttribute(
            'aria-label',
            `Live 3D PVC keychain preview: ${displayText}, font ${this.selectedFontLabel}, ${this.selectedTextColor} text on ${this.selectedBgColor} background`
          );
        }
        this._previewText = displayText;
        this.requestPreviewRender();

        // Format exact English summary string per Sections A, B, C:
        // - Upload mode: `Custom Icon: [uploaded] | Text: [tên] | Font: #N | Text color: [màu] | Background: [màu]`
        // - Preset mode: `Style: #1 | Text: [tên] | Font: #N | Text color: [màu] | Background: [màu]`
        const textForOrder = rawName || '';
        const stylePrefixOrder = this.isUploadMode
          ? 'Custom Icon: [uploaded]'
          : `Style: ${this.selectedIcon}`;
        const stylePrefixPreview = this.isUploadMode
          ? `Custom Icon: ${this.hasUploadedIcon ? '[uploaded]' : '[not uploaded]'}`
          : `Style: ${this.selectedIcon}`;

        const summaryValue = `${stylePrefixOrder} | Text: ${textForOrder} | Font: ${this.selectedFontLabel} | Text color: ${this.selectedTextColor} | Background: ${this.selectedBgColor} | Background style: ${this.selectedBgStyle}`;

        if (this.summaryInput) {
          this.summaryInput.value = summaryValue;
        }
        if (this.previewSummary) {
          this.previewSummary.textContent = `${stylePrefixPreview} | Text: ${displayText}${rawName ? '' : ' (example)'} | Font: ${this.selectedFontLabel} | Text color: ${this.selectedTextColor} | Background: ${this.selectedBgColor} | Background style: ${this.selectedBgStyle}`;
        }
      }

      /* ================================================================
       * Live 3D PVC Preview — die-cut renderer
       * Proportions measured from production reference sheets:
       *   - Contour Cut: outline hugs letters + icon at ~15% of cap height
       *   - Classic Bar: fixed rounded plate behind the name, icon with thin rim
       *   - Round keyring tab (r ~0.2x cap) on the far left with punched hole
       *   - Counters/gaps inside the contour are filled (solid die-cut)
       * ================================================================ */
      requestPreviewRender() {
        if (!this.previewCanvas || this._renderQueued) return;
        this._renderQueued = true;
        const run = () => {
          this._renderQueued = false;
          try {
            this.renderPreview();
          } catch (err) {
            if (window.console) console.warn('[cc-name-tag] preview render failed', err);
          }
        };
        if (window.requestAnimationFrame) window.requestAnimationFrame(run);
        else setTimeout(run, 16);
      }

      makeCanvas(w, h) {
        const c = document.createElement('canvas');
        c.width = Math.max(1, Math.ceil(w));
        c.height = Math.max(1, Math.ceil(h));
        return c;
      }

      tintCanvas(src, color) {
        const c = this.makeCanvas(src.width, src.height);
        const x = c.getContext('2d');
        x.drawImage(src, 0, 0);
        x.globalCompositeOperation = 'source-in';
        x.fillStyle = color;
        x.fillRect(0, 0, c.width, c.height);
        return c;
      }

      trimIconCanvas(c) {
        try {
          const w = c.width;
          const h = c.height;
          const d = c.getContext('2d').getImageData(0, 0, w, h).data;
          let x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (let y = 0; y < h; y++) {
            for (let x = 0; x < w; x++) {
              if (d[(y * w + x) * 4 + 3] > 20) {
                if (x < x0) x0 = x;
                if (x > x1) x1 = x;
                if (y < y0) y0 = y;
                if (y > y1) y1 = y;
              }
            }
          }
          if (x1 < 0) return { canvas: c, tainted: false };
          const t = this.makeCanvas(x1 - x0 + 1, y1 - y0 + 1);
          t.getContext('2d').drawImage(c, x0, y0, t.width, t.height, 0, 0, t.width, t.height);
          return { canvas: t, tainted: false };
        } catch (e) {
          return { canvas: c, tainted: true };
        }
      }

      getSpriteImage() {
        if (this._spriteImg) return this._spriteImg;
        if (!this.iconSpriteUrl) return null;
        let url = this.iconSpriteUrl;
        if (url.indexOf('//') === 0) url = window.location.protocol + url;
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          this._iconCache = {};
          this.requestPreviewRender();
        };
        img.onerror = () => {
          if (this._spriteRetried) return;
          this._spriteRetried = true;
          const plain = new Image();
          plain.onload = () => {
            this._iconCache = {};
            this.requestPreviewRender();
          };
          plain.src = url;
          this._spriteImg = plain;
        };
        img.src = url;
        this._spriteImg = img;
        return img;
      }

      getPreviewIcon() {
        if (this.hasIcons) {
          const img = this.getSpriteImage();
          if (!img || !img.complete || !img.naturalWidth) return null;
          const count = Math.max(1, this.iconCount);
          const idx = Math.min(count - 1, Math.max(0, (parseInt(String(this.selectedIcon).replace(/\D/g, ''), 10) || 1) - 1));
          if (this._iconCache[idx]) return this._iconCache[idx];
          const cellW = img.naturalWidth / count;
          const cellH = img.naturalHeight;
          const c = this.makeCanvas(cellW, cellH);
          c.getContext('2d').drawImage(img, idx * cellW, 0, cellW, cellH, 0, 0, c.width, c.height);
          const res = this.trimIconCanvas(c);
          this._iconCache[idx] = res;
          return res;
        }
        if (this.isUploadMode) {
          const img = this._uploadedIconImg;
          if (this.hasUploadedIcon && img && img.complete && img.naturalWidth) {
            if (!this._uploadedIconCanvas) {
              const c = this.makeCanvas(img.naturalWidth, img.naturalHeight);
              c.getContext('2d').drawImage(img, 0, 0);
              this._uploadedIconCanvas = this.trimIconCanvas(c);
            }
            return this._uploadedIconCanvas;
          }
          return { placeholder: true };
        }
        return null;
      }

      ensurePreviewFont(family, text) {
        if (!document.fonts || !document.fonts.load) return;
        const key = family + (/[^\x00-\x7F]/.test(text) ? '|' + text : '');
        if (this._fontLoadState[key]) return;
        this._fontLoadState[key] = 'loading';
        document.fonts
          .load(`80px ${family}`, text)
          .then(() => {
            this._fontLoadState[key] = 'done';
            this.requestPreviewRender();
          })
          .catch(() => {
            this._fontLoadState[key] = 'done';
          });
      }

      drawUploadPlaceholder(ctx, cx, cy, r) {
        ctx.save();
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.fillStyle = '#ffffff';
        ctx.fill();
        ctx.setLineDash([r * 0.16, r * 0.12]);
        ctx.lineWidth = Math.max(1.5, r * 0.06);
        ctx.strokeStyle = '#94a3b8';
        ctx.beginPath();
        ctx.arc(cx, cy, r * 0.86, 0, Math.PI * 2);
        ctx.stroke();
        ctx.setLineDash([]);
        const s = r * 0.9;
        const x0 = cx - s / 2;
        const y0 = cy - s / 2;
        ctx.lineWidth = Math.max(1.5, r * 0.085);
        ctx.strokeStyle = '#2a2118';
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
        const rr = s * 0.18;
        ctx.beginPath();
        ctx.moveTo(x0 + rr, y0);
        ctx.arcTo(x0 + s, y0, x0 + s, y0 + s, rr);
        ctx.arcTo(x0 + s, y0 + s, x0, y0 + s, rr);
        ctx.arcTo(x0, y0 + s, x0, y0, rr);
        ctx.arcTo(x0, y0, x0 + s, y0, rr);
        ctx.closePath();
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x0 + s * 0.33, y0 + s * 0.33, s * 0.09, 0, Math.PI * 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(x0 + s * 0.08, y0 + s * 0.92);
        ctx.lineTo(x0 + s * 0.62, y0 + s * 0.45);
        ctx.lineTo(x0 + s * 0.98, y0 + s * 0.78);
        ctx.stroke();
        ctx.restore();
      }

      renderPreview() {
        const canvas = this.previewCanvas;
        if (!canvas || !canvas.getContext) return;
        const text = this._previewText || this.defaultPreview || 'NAME';
        const family = this.selectedFontFamily || 'sans-serif';
        const isBar = this.selectedBgStyle === 'Classic Bar';
        this.ensurePreviewFont(family, text);

        // ---- 1. Measure the typed name and scale it so its letters fill the tag height ----
        //   Sized by the real ink height of the typed text (not a generic 'H'), so lowercase /
        //   small-cap names (e.g. font #20) are as bold & tall as the reference tags.
        const C = 84; // internal letter height in px
        const meas = this._measCtx || (this._measCtx = this.makeCanvas(4, 4).getContext('2d'));
        meas.font = `100px ${family}`;
        const capRaw = meas.measureText('H').actualBoundingBoxAscent || 70;
        const inkRaw = meas.measureText(text).actualBoundingBoxAscent || capRaw;
        const refRaw = Math.min(capRaw * 1.12, Math.max(capRaw * 0.72, inkRaw));
        const fontPx = Math.max(20, (100 * C) / Math.max(20, refRaw));
        const font = `${fontPx.toFixed(2)}px ${family}`;
        meas.font = font;
        const tm = meas.measureText(text);
        const tAsc = Math.max(tm.actualBoundingBoxAscent || C, C * 0.55);
        const tDesc = Math.max(0, tm.actualBoundingBoxDescent || 0);
        const tLeft = tm.actualBoundingBoxLeft || 0;
        const tRight = tm.actualBoundingBoxRight || tm.width;

        // ---- 2. Proportions measured from production reference sheets (relative to cap height C) ----
        //   Contour Cut : outline ~15% of cap height, icon ~1.4x cap height
        //   Classic Bar : rounded plate ~1.26x letter height (letters fill ~80% of the plate),
        //                 icon ~1.62x letter height (~1.3x plate) with thin ~7% rim
        const R = isBar ? C * 0.07 : C * 0.15;   // outline thickness around icon (and letters in contour mode)
        const T = C * 0.23;                       // keyring tab outer radius
        const holeR = C * 0.09;                   // punched hole radius
        const depth = Math.max(4, Math.round(C * 0.075)); // PVC thickness (3D side wall)
        const capMidY = -C / 2;                   // baseline is y = 0

        // icon box
        const icon = this.getPreviewIcon();
        const iconTarget = isBar ? C * 1.62 : C * 1.42;
        const iconMaxW = isBar ? C * 2.1 : C * 2.0;
        let iconW = 0, iconH = 0, placeholderR = 0;
        if (icon && icon.placeholder) {
          placeholderR = iconTarget * 0.47;
          iconW = iconH = placeholderR * 2;
        } else if (icon && icon.canvas) {
          const aspect = icon.canvas.width / Math.max(1, icon.canvas.height);
          const scale = icon.tainted ? 1 / 0.91 : 1; // untrimmed sprite cells carry ~9% padding
          iconH = iconTarget * scale;
          iconW = iconH * aspect;
          if (iconW > iconMaxW * scale) {
            iconW = iconMaxW * scale;
            iconH = iconW / aspect;
          }
        }
        const hasIconBox = iconW > 0;
        const iconX = 0;
        const iconY = capMidY - iconH / 2;
        const gap = hasIconBox ? C * 0.06 : 0;
        const textX = (hasIconBox ? iconX + iconW + gap : 0) + tLeft;
        const textInkLeft = textX - tLeft;
        const textInkRight = textX + tRight;

        // Classic Bar plate geometry (stadium shape)
        let barTop = 0, barBot = 0, barX0 = 0, barX1 = 0, barRad = 0;
        if (isBar) {
          barTop = Math.min(capMidY - C * 0.63, -tAsc - C * 0.11);
          barBot = Math.max(capMidY + C * 0.63, tDesc + C * 0.11);
          barRad = (barBot - barTop) / 2;
          barX0 = hasIconBox ? iconX + iconW * 0.5 : textInkLeft - barRad * 0.9;
          barX1 = textInkRight + barRad * 0.85;
        }

        // keyring tab on the far-left edge, centred vertically
        const leftEdge = hasIconBox ? iconX - R : (isBar ? barX0 : textInkLeft - R);
        const tabCx = leftEdge - T * 0.62;
        const tabCy = capMidY;
        const bridgeEndX = hasIconBox ? iconX + iconW * 0.3 : (isBar ? barX0 + barRad : textInkLeft + C * 0.25);

        // ---- 3. Canvas bounds ----
        const pad = C * 0.12;
        const minX = tabCx - T - pad;
        const maxX = (isBar ? Math.max(barX1, textInkRight + R) : textInkRight + R) + pad;
        let topInk = Math.min(hasIconBox ? iconY : 0, -tAsc) - R;
        let botInk = Math.max(hasIconBox ? iconY + iconH : 0, tDesc) + R;
        if (isBar) {
          topInk = Math.min(topInk, barTop);
          botInk = Math.max(botInk, barBot);
        }
        const minY = topInk - pad;
        const maxY = botInk + depth + pad + C * 0.12;
        const W = Math.ceil(maxX - minX);
        const H = Math.ceil(maxY - minY);
        const ox = -minX;
        const oy = -minY;

        // ---- 4. Build die-cut mask ----
        const mask = this.makeCanvas(W, H);
        const m = mask.getContext('2d');
        m.fillStyle = '#000';
        m.strokeStyle = '#000';
        m.lineJoin = 'round';
        m.lineCap = 'round';

        if (isBar) {
          // fixed rounded plate
          const x0 = ox + barX0, x1 = ox + barX1, y0 = oy + barTop, y1 = oy + barBot, r = barRad;
          m.beginPath();
          m.moveTo(x0 + r, y0);
          m.lineTo(x1 - r, y0);
          m.arc(x1 - r, y0 + r, r, -Math.PI / 2, Math.PI / 2);
          m.lineTo(x0 + r, y1);
          m.arc(x0 + r, y0 + r, r, Math.PI / 2, Math.PI * 1.5);
          m.closePath();
          m.fill();
          // keep any overhanging glyph (script swashes) inside the plate
          m.font = font;
          m.textAlign = 'left';
          m.textBaseline = 'alphabetic';
          m.lineWidth = C * 0.1;
          m.fillText(text, ox + textX, oy);
          m.strokeText(text, ox + textX, oy);
        } else {
          // contour: letters dilated by R
          m.font = font;
          m.textAlign = 'left';
          m.textBaseline = 'alphabetic';
          m.lineWidth = R * 2;
          m.fillText(text, ox + textX, oy);
          m.strokeText(text, ox + textX, oy);
        }

        if (placeholderR) {
          m.beginPath();
          m.arc(ox + iconX + placeholderR, oy + capMidY, placeholderR + R, 0, Math.PI * 2);
          m.fill();
        } else if (hasIconBox) {
          const sil = this.makeCanvas(iconW, iconH);
          const sx = sil.getContext('2d');
          sx.drawImage(icon.canvas, 0, 0, sil.width, sil.height);
          sx.globalCompositeOperation = 'source-in';
          sx.fillStyle = '#000';
          sx.fillRect(0, 0, sil.width, sil.height);
          const rings = [R, R * 0.66, R * 0.33];
          rings.forEach((rad, ri) => {
            const steps = ri === 0 ? 36 : 18;
            for (let k = 0; k < steps; k++) {
              const ang = (k / steps) * Math.PI * 2;
              m.drawImage(sil, ox + iconX + Math.cos(ang) * rad, oy + iconY + Math.sin(ang) * rad);
            }
          });
          m.drawImage(sil, ox + iconX, oy + iconY);
        }

        // keyring tab + smooth bridge into the body
        m.beginPath();
        m.arc(ox + tabCx, oy + tabCy, T, 0, Math.PI * 2);
        m.fill();
        m.beginPath();
        m.moveTo(ox + tabCx, oy + tabCy);
        m.lineTo(ox + bridgeEndX, oy + tabCy);
        m.lineWidth = T * 1.3;
        m.stroke();

        // ---- 5. Smooth concave corners + fill enclosed holes (solid die-cut body) ----
        const body = this.makeCanvas(W, H);
        const bctx = body.getContext('2d');
        const blurPx = C * (isBar ? 0.025 : 0.045);
        if ('filter' in bctx) bctx.filter = `blur(${blurPx.toFixed(1)}px)`;
        bctx.drawImage(mask, 0, 0);
        if ('filter' in bctx) bctx.filter = 'none';
        try {
          const id = bctx.getImageData(0, 0, W, H);
          const d = id.data;
          const n = W * H;
          const ext = new Uint8Array(n);
          const q = new Int32Array(n);
          let qh = 0, qt = 0;
          const push = (px) => {
            if (!ext[px] && d[px * 4 + 3] < 128) {
              ext[px] = 1;
              q[qt++] = px;
            }
          };
          for (let x = 0; x < W; x++) {
            push(x);
            push((H - 1) * W + x);
          }
          for (let y = 0; y < H; y++) {
            push(y * W);
            push(y * W + W - 1);
          }
          while (qh < qt) {
            const px = q[qh++];
            const x = px % W;
            if (x > 0) push(px - 1);
            if (x < W - 1) push(px + 1);
            if (px >= W) push(px - W);
            if (px < n - W) push(px + W);
          }
          for (let px = 0; px < n; px++) {
            const i = px * 4;
            d[i] = d[i + 1] = d[i + 2] = 0;
            if (!ext[px]) d[i + 3] = 255;
            else d[i + 3] = Math.max(0, Math.min(255, (d[i + 3] - 128) * 3 + 128));
          }
          bctx.putImageData(id, 0, 0);
        } catch (e) {
          /* cross-origin icon: keep blurred mask without hole filling */
        }
        // punch the keyring hole
        bctx.globalCompositeOperation = 'destination-out';
        bctx.beginPath();
        bctx.arc(ox + tabCx, oy + tabCy, holeR, 0, Math.PI * 2);
        bctx.fill();
        bctx.globalCompositeOperation = 'source-over';

        // ---- 6. Paint ----
        const bgHex = this.selectedBgHex || '#E53935';
        const txtHex = this.selectedTextHex || '#FFFFFF';
        const bgSide = this.selectedBgColor === 'Black' ? '#000000' : this.shadeColor(bgHex, 0.62);
        const txtSide = this.selectedTextColor === 'Black' ? '#000000' : this.shadeColor(txtHex, 0.7);

        if (canvas.width !== W) canvas.width = W;
        if (canvas.height !== H) canvas.height = H;
        const displayScale = 0.42; // internal px -> CSS px (cap height ~35px on screen)
        canvas.style.width = `${Math.round(W * displayScale)}px`;
        const v = canvas.getContext('2d');
        v.clearRect(0, 0, W, H);

        // 6a. PVC side wall + soft cast shadow
        const side = this.tintCanvas(body, bgSide);
        v.save();
        v.shadowColor = 'rgba(0, 0, 0, 0.5)';
        v.shadowBlur = C * 0.14;
        v.shadowOffsetY = C * 0.06;
        v.drawImage(side, 0, depth);
        v.restore();
        for (let i = depth - 1; i >= 1; i--) v.drawImage(side, 0, i);

        // 6b. top face (flat PVC background colour)
        v.drawImage(this.tintCanvas(body, bgHex), 0, 0);

        // 6c. soft bevel highlight along the top edge
        const rim = this.tintCanvas(body, 'rgba(255, 255, 255, 0.38)');
        const rx = rim.getContext('2d');
        rx.globalCompositeOperation = 'destination-out';
        rx.drawImage(body, 0, Math.max(2, C * 0.03));
        v.drawImage(rim, 0, 0);

        // 6d. icon (raised layer)
        if (placeholderR) {
          this.drawUploadPlaceholder(v, ox + iconX + placeholderR, oy + capMidY, placeholderR);
        } else if (hasIconBox) {
          v.save();
          v.shadowColor = 'rgba(0, 0, 0, 0.35)';
          v.shadowBlur = C * 0.025;
          v.shadowOffsetY = C * 0.035;
          v.drawImage(icon.canvas, ox + iconX, oy + iconY, iconW, iconH);
          v.restore();
        }

        // 6e. raised name letters
        v.font = font;
        v.textAlign = 'left';
        v.textBaseline = 'alphabetic';
        const tDepth = Math.max(2, Math.round(C * 0.04));
        v.fillStyle = txtSide;
        for (let i = tDepth; i >= 1; i--) v.fillText(text, ox + textX, oy + i);
        v.fillStyle = txtHex;
        v.fillText(text, ox + textX, oy);
      }

      setupCheckoutGuard() {
        const validateOrder = (e) => {
          // 1. In upload mode, verify icon is uploaded and rights checkbox is checked
          if (this.isUploadMode) {
            if (!this.hasUploadedIcon) {
              e.preventDefault();
              e.stopPropagation();
              if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
              this.showUploadError('Please upload your custom icon (PNG or JPG) before adding to cart.');
              if (this.uploadDropzone) {
                this.uploadDropzone.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
              return false;
            }
            if (this.rightsCheckbox && !this.rightsCheckbox.checked) {
              e.preventDefault();
              e.stopPropagation();
              if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
              this.showUploadError('Please confirm that you have the rights to use this uploaded image.');
              this.rightsCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
              setTimeout(() => this.rightsCheckbox.focus(), 200);
              return false;
            }
          }

          // 2. Verify Name is entered (1–12 characters)
          const val = this.nameInput ? this.nameInput.value.trim() : '';
          if (!val) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            if (this.nameError) this.nameError.hidden = false;
            if (this.nameInput) {
              this.nameInput.classList.add('is-invalid');
              this.nameInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
              setTimeout(() => this.nameInput.focus(), 250);
            }
            return false;
          }
          return true;
        };

        const productForm = this.closest('product-form-component') || document.querySelector('product-form-component');
        if (productForm) {
          productForm.addEventListener('submit', validateOrder, true);
          productForm.addEventListener('click', (e) => {
            const btn = e.target && e.target.closest
              ? e.target.closest('button[type="submit"], button[name="add"], .add-to-cart-button, .shopify-payment-button')
              : null;
            if (btn) validateOrder(e);
          }, true);
        }

        document.addEventListener('click', (e) => {
          const stickyBtn = e.target && e.target.closest
            ? e.target.closest('.sticky-add-to-cart__button')
            : null;
          if (stickyBtn) validateOrder(e);
        }, true);
      }
    }
    customElements.define('cc-name-tag-builder', CcNameTagBuilder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cc-share-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const btn = event.target.closest('.cc-share__copy');
    if (!btn) return;
    const toast = btn.parentElement.querySelector('.cc-share__toast');
    navigator.clipboard?.writeText(btn.dataset.url).then(() => {
      if (!toast) return;
      toast.textContent = 'Link copied';
      setTimeout(() => (toast.textContent = ''), 2000);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
